import PropTypes from "prop-types";
import React from "react";
import { PulseLoader } from "react-spinners";
import { Button as Btn } from "reactstrap";

const Button = ({
  disabled,
  loading,
  text,
  children,
  loadingIndicatorSize,
  loadingIndicatorColor,
  className,
  ...othersProps
}) => (
  <Btn
    className={className ? className : "text-white"}
    {...othersProps}
    disabled={disabled || loading}
  >
    {loading ? (
      <PulseLoader size={loadingIndicatorSize} color={loadingIndicatorColor} />
    ) : (
      children || text
    )}
  </Btn>
);

Button.propTypes = {
  text: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  loadingIndicatorSize: PropTypes.number,
  loadingIndicatorColor: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string
};

Button.defaultProps = {
  text: null,
  loading: false,
  disabled: false,
  loadingIndicatorSize: 10,
  loadingIndicatorColor: "#fff",
  children: null
};

export default Button;
